import variables from '@ingka/variables/colours-css';

export default {
  background: {
    alternative: variables.colourNeutral3,
    accent: variables.colourStaticIkeaBrandBlue,
    default: variables.colourNeutral1,
    error: '#fff1f1',
  },
  icon: {
    default: variables.colourTextAndIcon1,
  },
  neutral: {
    white: variables.colourNeutral1,
    grey100: variables.colourNeutral2,
    grey200: variables.colourNeutral3,
    grey300: variables.colourNeutral4,
    grey500: variables.colourNeutral5,
  },
  text: {
    default: variables.colourTextAndIcon2,
    black: variables.colourTextAndIcon1,
    disabled: variables.colourTextAndIcon3,
    grey4: variables.colourTextAndIcon4,
    inverse: variables.colourTextAndIcon5,
    error: variables.colourSemanticNegative,
  },
  static: {
    white: variables.colourStaticWhite,
    ikeaBlue: variables.colourStaticIkeaFamily,
    // Unlike ikeaBlue, this lightens in dark theme to keep text contrast.
    ikeaFamilyText: variables.colourCommercialMessageIkeaFamily,
    green: '#0dcb00',
  },
  semantic: {
    positive: variables.colourSemanticPositive,
  },
  interactive: {
    default: variables.colourNeutral3,
    defaultHover: variables.colourNeutral4,
    emphasised: variables.colourInteractiveEmphasisedBgDefault,
    emphasisedHover: variables.colourInteractiveEmphasisedBgHover,
    borderEmphasised: 'rgba(0, 88, 163, 0.61)',
  },
};
